"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : userNew.js
* Description : Ce fichier contient la définition de la page userNew 
*               Cette page fourni un formulaire pour créer un utilisateur
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ /* Hook */ /**
* userNew : affiche une page avec un formulaire pour créer un utilisateur
*                un lien permet de revenir sur la page qui liste tous les utilisateurs 
*
* Type : page 
*
* Parametres : 
*  None
*/
function UserNew() {
  // Define useState hooks
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRole = _useState2[0],
    setSelectedRole = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedCompanyUser = _useState4[0],
    setSelectedCompanyUser = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    firstName = _useState6[0],
    setFirstName = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    lastName = _useState8[0],
    setLastName = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState0 = _slicedToArray(_useState9, 2),
    username = _useState0[0],
    setUsername = _useState0[1];
  var _useState1 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState1, 2),
    email = _useState10[0],
    setEmail = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    roles = _useState12[0],
    setRoles = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    companies = _useState14[0],
    setCompanies = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    statusUser = _useState16[0],
    setStatusUser = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    firstNameError = _useState18[0],
    setFirstNameError = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    lastNameError = _useState20[0],
    setLastNameError = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    usernameError = _useState22[0],
    setUsernameError = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    emailError = _useState24[0],
    setEmailError = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    emailFormatError = _useState26[0],
    setEmailFormatError = _useState26[1];
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    roleError = _useState28[0],
    setRoleError = _useState28[1];
  var _useState29 = (0, _react.useState)(false),
    _useState30 = _slicedToArray(_useState29, 2),
    companyError = _useState30[0],
    setCompanyError = _useState30[1];
  var _useState31 = (0, _react.useState)(false),
    _useState32 = _slicedToArray(_useState31, 2),
    formSubmit = _useState32[0],
    setFormSubmit = _useState32[1];
  var _useState33 = (0, _react.useState)(false),
    _useState34 = _slicedToArray(_useState33, 2),
    skipPrompt = _useState34[0],
    setSkipPrompt = _useState34[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    selectedCompany = _useApi.selectedCompany,
    applicationName = _useApi.applicationName;
  var navigate = (0, _reactRouterDom.useNavigate)();

  // Define useBlocker hooks
  var shouldBlock = (firstName !== "" || lastName !== "" || email !== "" || selectedCompany !== "0" && selectedCompany !== 0 || selectedRole !== "0" && selectedRole !== 0) && skipPrompt === false;
  var blocker = (0, _reactRouterDom.useBlocker)(shouldBlock);

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function capitalize(text) {
    // First letter in Uppercase and others in LowerCase
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  function sendData(_x, _x2, _x3, _x4, _x5, _x6) {
    return _sendData.apply(this, arguments);
  }
  function _sendData() {
    _sendData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(first_name, last_name, username, email, role_id, company_id) {
      var token, form_data, response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Création du Form Data
            form_data = new FormData();
            form_data.append("first_name", first_name);
            form_data.append("last_name", last_name);
            form_data.append("username", username);
            form_data.append("email", email);
            form_data.append("role_id", Number(role_id));
            form_data.append("company_id", Number(company_id));
            // Create User
            _context.n = 1;
            return fetch(path + "/api/au-erus/", {
              method: 'POST',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              },
              body: form_data
            });
          case 1:
            response = _context.v;
            setStatusUser(response["status"]);
            setFormSubmit(false);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _sendData.apply(this, arguments);
  }
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    setSkipPrompt(true);
    if (firstName === null || firstName === '') {
      setFirstNameError(true);
    } else {
      setFirstNameError(false);
    }
    if (lastName === null || lastName === '') {
      setLastNameError(true);
    } else {
      setLastNameError(false);
    }
    if (username === null || username === '') {
      setUsernameError(true);
    } else {
      setUsernameError(false);
    }
    if (email === null || email === '') {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    if (selectedRole === 0 || selectedRole === '0') {
      setRoleError(true);
    } else {
      setRoleError(false);
    }
    if (selectedCompanyUser === 0 || selectedCompanyUser === '0') {
      setCompanyError(true);
    } else {
      setCompanyError(false);
    }
    if (email.match(/\w*@\w*[.]\w{2,3}/) === null) {
      setEmailFormatError(true);
    } else {
      setEmailFormatError(false);
    }
    setFormSubmit(true);
  };
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var token, headers, urlRole, resRole, dataRole, url, response, dataCompany;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Roles
            if (Number(selectedCompanyUser) > 1) {
              urlRole = path + "/api/au-lero/extract-company-role/";
            } else {
              urlRole = path + "/api/au-lero/extract-responsible/";
            }
            _context2.n = 1;
            return fetch(urlRole, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 1:
            resRole = _context2.v;
            _context2.n = 2;
            return resRole.json();
          case 2:
            dataRole = _context2.v;
            setRoles(dataRole);
            // Companies

            if (applicationName === 'BOXILUMIX') {
              url = path + "/api/au-cony/" + selectedCompany;
            } else {
              url = path + "/api/au-cony/";
            }
            _context2.n = 3;
            return fetch(url, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 3:
            response = _context2.v;
            _context2.n = 4;
            return response.json();
          case 4:
            dataCompany = _context2.v;
            if (applicationName === 'BOXILUMIX') {
              setCompanies([dataCompany]);
            } else {
              setCompanies(dataCompany["results"]);
            }
            setSelectedCompanyUser(selectedCompany);
          case 5:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _retrieveData.apply(this, arguments);
  }
  function retrieveRoles() {
    return _retrieveRoles.apply(this, arguments);
  } // Define useEffect hooks
  function _retrieveRoles() {
    _retrieveRoles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var token, urlRole, resRole, dataRole;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Roles
            if (Number(selectedCompanyUser) > 1) {
              urlRole = path + "/api/au-lero/extract-company-role/";
            } else if (Number(selectedCompanyUser) === 1) {
              urlRole = path + "/api/au-lero/extract-at-role/";
            } else {
              urlRole = path + "/api/au-lero/extract-responsible/";
            }
            _context3.n = 1;
            return fetch(urlRole, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resRole = _context3.v;
            _context3.n = 2;
            return resRole.json();
          case 2:
            dataRole = _context3.v;
            setRoles(dataRole);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _retrieveRoles.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    retrieveRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompanyUser]);
  (0, _react.useEffect)(function () {
    var first_name = firstName[0];
    var user_name = first_name + lastName;
    setUsername(user_name.toLowerCase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName, lastName]);
  (0, _react.useEffect)(function () {
    if (formSubmit === true && firstNameError === false && lastNameError === false && usernameError === false && emailError === false && roleError === false && companyError === false && emailFormatError === false) {
      sendData(firstName, lastName, username, email, selectedRole, selectedCompanyUser);
    } else {
      setSkipPrompt(false);
      setFormSubmit(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formSubmit]);
  (0, _react.useEffect)(function () {
    if (statusUser === 201) {
      navigate('/users/');
    } else {
      setFormSubmit(false);
      navigate('/users/new');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusUser, navigate]);
  (0, _react.useEffect)(function () {
    // Bloquer la fermeture d'onglet/rafraîchissement
    var handleBeforeUnload = function handleBeforeUnload(e) {
      if (shouldBlock === true) {
        // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
        e.preventDefault();
        e.returnValue = "";
        // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
        return e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Nettoyer l'écouteur quand le composant est démonté
    return function () {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldBlock]);
  (0, _react.useEffect)(function () {
    if (blocker.state === "blocked") {
      var confirmed = window.confirm("Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
      if (confirmed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 5
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dist.Container, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          children: "Cr\xE9er un nouvel utilisateur"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex-row justify-start margin-left margin-bottom margin-top",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "link-border",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
              path: "/users",
              children: "Retour \xE0 la liste des utilisateurs"
            })
          })
        }), emailFormatError !== false ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "form-error",
          children: "L'email ne respecte pas le bon format."
        }) : statusUser !== null && statusUser !== 201 && firstNameError === false && lastNameError === false && usernameError === false && emailError === false && roleError === false && companyError === false ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "form-error",
          children: "L'utilisateur existe d\xE9j\xE0 ou n'a pas pu \xEAtre enregistr\xE9 !"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
          onSubmit: handleSubmit,
          className: "flex-column",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex-column form-center",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.InputForm, {
              error: firstNameError,
              type: "text",
              label: "Pr\xE9nom",
              value: capitalize(firstName),
              setValue: setFirstName,
              disabled: false
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.InputForm, {
              error: lastNameError,
              type: "text",
              label: "Nom",
              value: lastName.toUpperCase(),
              setValue: setLastName,
              disabled: false
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.InputForm, {
              error: usernameError,
              type: "text",
              label: "Username",
              value: username,
              setValue: setUsername,
              disabled: true
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.InputForm, {
              error: emailError,
              type: "email",
              label: "Email",
              value: email,
              setValue: setEmail,
              disabled: false
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.SelectForm, {
              error: companyError,
              labelText: "Soci\xE9t\xE9",
              choices: companies.sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              }),
              selectedItem: selectedCompanyUser,
              setSelectedItem: setSelectedCompanyUser
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.SelectForm, {
              error: roleError,
              labelText: "Role",
              choices: roles.sort(function (a, b) {
                return a.description > b.description ? 1 : -1;
              }),
              selectedItem: selectedRole,
              setSelectedItem: setSelectedRole
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {})]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex-row justify-end",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              type: "submit",
              className: "button",
              children: "Valider"
            })
          })]
        })]
      })
    })]
  });
}
var _default = exports["default"] = UserNew;